/* istanbul ignore file */

import { BasicDropdownValue } from '../basic-dropdown-value';

export class MapPinColorSelection extends BasicDropdownValue {
    color: string;
    isUsed = false;
    mapPinIcon: string;
}
